module.exports = __webpack_public_path__ + "fonts/bootstrap-icons.1a51dfbe.woff";